/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-21 15:50:23
 */
import ColumnTypes from '@/utils/ColumnTypes';

const colonelActivitySquare = {
	key: 'colonelActivitySquare',
	label: '商品信息',
	type: () => import('./components/ksTableCell/channelShopCell'),
	minWidth: '400',
	fixed: 'left',
};
const itemPrice = {
	key: 'itemPrice',
	label: '单价',
	minWidth: '120',
	type: ColumnTypes.TextCell,
};
const itemStock = {
	key: 'itemStock',
	label: '库存',
	minWidth: '120',
	type: ColumnTypes.TextCell,
};
const stock_num = {
	key: 'stock_num',
	label: '推广周期',
	startTime: 'cooperateBeginTime',
	endTime: 'cooperateEndTime',
	type: () => import('./components/ksTableCell/extensionTimeCell'),
	minWidth: '200',
};
const cooperateBeginTime = {
	key: 'cooperateBeginTime',
	label: '合作推广时间',
	startTime: 'cooperateBeginTime',
	endTime: 'cooperateEndTime',
	type: () => import('./components/ksTableCell/extensionTimeCell'),
	minWidth: '180',
};
const itemVolume = {
	key: 'itemVolume',
	label: '累计销量(件)',
	minWidth: '120',
	type: ColumnTypes.TextCell,
};
const investmentPromotionRate = {
	key: 'investmentPromotionRate',
	label: '服务费率',
	type: ColumnTypes.serviceRateCell,
	minWidth: '100',
};
const itemCommissionRate = {
	key: 'itemCommissionRate',
	label: '佣金率',
	minWidth: '80',
	type: ColumnTypes.serviceRateCell,
};
const todoPromote = {
	key: 'todoPromote',
	label: '商品推广状态',
	type: () => import('./components/ksTableCell/promotionCell'),
	minWidth: '140',
};
const sellerNickName = {
	key: 'sellerNickName',
	label: '推广者信息',
	minWidth: '120',
	type: ColumnTypes.TextCell,
};
const preActivityId = {
	key: 'preActivityId',
	label: '活动ID',
	type: ColumnTypes.TextCell,
	minWidth: '160',
};
const operations = {
	key: 'operations',
	label: '操作',
	minWidth: '120',
	fixed: 'right',
	type: ColumnTypes.ButtonsCell,
	align: 'right',
};

export const column_not = [
	colonelActivitySquare,
	itemPrice,
	itemStock,
	stock_num,
	itemVolume,
	investmentPromotionRate,
	itemCommissionRate,
	operations,
];
export const column_success = [colonelActivitySquare, sellerNickName, cooperateBeginTime, todoPromote, preActivityId, operations];
